import Button from './Button';
import {useNavigate} from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { useRef, useState } from 'react';
import Phone from './Phone';

const CenterSearchResult = ({friendly_url, name, type, address, city, state, zip, phone, distance, physicians}) => {

    
    let navigate = useNavigate();
    const tooltipRef = useRef();
    const [copiedText, setCopied] = useState(false);

    let physiciansList = physicians.map((physician, index) => {return <p key={index} className={`float-right ${physician.by_physician === 1 &&  'by-physician'}`}>{physician.first_name} {physician.last_name}, {physician.title}</p>;});

    const addressClickHandle = (address, city, state, zip) => {
        navigator.clipboard.writeText(`${address} ${city}, ${state} ${zip}`);
        ReactTooltip.show(tooltipRef.current);
        setCopied(true);
        setTimeout(() => {ReactTooltip.hide(tooltipRef.current); setCopied(false);}, 2000);
    };

    return (
        <div className="shadow-box margin-bottom" id={`location-${friendly_url}`}>
            <div className="third">
                <img alt={name} src='/find-doctors/images/default-center.png' />
                { distance !== -1 &&  <p>Distance: {distance} mi</p>}               
            </div>
            <div className="third">
                <h4>{name}</h4>
                <p className="sub-header">{type}</p>
                <p className={copiedText ? 'address-tooltip only-address' : 'address-tooltip'} onClick={() => addressClickHandle(address, city, state, zip)} ref={tooltipRef}  data-tip="Address Copied!" data-for="address-tooltip" data-event="custom">{address}<br /> {city}, {state} {zip}</p>
                <Phone>{phone}</Phone>

                <ReactTooltip id="address-tooltip"  place="top" type="dark" effect="float" eventOff="click" />
            </div>
            <div className="third">
               <Button clickHandle={(e) => navigate(`/find-doctors/centers/${friendly_url}`)}>View Location</Button>
                <div className='margin-top'>
                {physiciansList}
                </div>
            </div>
        </div>
    );
}

export default CenterSearchResult;